import { RecoverableBinding, recoverableFieldWithOptions } from "../../../ServiceDesk/recovery/recoverable-control";

export class RadioBinding extends RecoverableBinding {
  /** The field member of the itemsSource object to be displayed if it is not an array of strings.*/
  public displayMember = "@?";

  /** Source array which contains the radio option values.*/
  public itemsSource = "<?";

  /** The ng-bind object which holds the selected value. */
  public model = "=?";

  /** The name bound to the input tags. */
  public name = "@";

  /** horizontal/vertical. The orientation of the radio. */
  public orientation = "@?";

  /** specify a function which given a model item, will return a unique id for it. Required for recovery. */
  public itemIdGetter = "&?";

  /** true/false. True if the format of radio item is in html format. */
  public renderAsHtml = "<?";
}

export class RadioController {
  // text to be shown based on the property name for complex objects
  displayMember: string;

  // list of items to bound
  itemsSource: any;

  renderAsHtml: boolean;

  // model to update on selection
  @recoverableFieldWithOptions({ preventAutomaticRecovery: true })
  model: any;

  // radio button group name
  name: string;

  // vertical or horizontal
  orientation: string;

  // orientation class will be set based on orientation
  orientationClass: string;

  itemIdGetter: (arg: { item: any }) => string;

  recoveryId: string;

  $onInit(): void {
    if (this.orientation === "horizontal") {
      this.orientationClass = "c-group";
    }
    if (this.recoveryId && !this.itemIdGetter) {
      throw new Error("recovery Id specified but no Id getter specified");
    }
  }

  $sdRecoveryPreserialize(key: string, model: any) {
    if (model) {
      return this.itemIdGetter({ item: model });
    }
    return undefined;
  }

  private getOptionFromRecoveryData(data: any) {
    return this.itemsSource.find((i: any) => this.itemIdGetter({ item: i }) == data.model);
  }

  $sdRecoveryOnComplete(data: any) {
    this.model = this.getOptionFromRecoveryData(data);
  }

  $sdRecoveryIsModelValid(data: any) {
    return data.model && this.getOptionFromRecoveryData(data);
  }
}
export const sdRadio: ng.IComponentOptions = {
  bindings: <any>new RadioBinding(),
  controller: RadioController,
  templateUrl: "../shellcommon/controls/radio/radio.html",
  transclude: true
};
